// Values must match the events.cancellation_reason ENUM in d4urx-api
// (db/migrations/D4URX-2749-event-cancellation-reason.sql).
export interface CancellationReason {
  value: string;
  label: string;
  // 'optional' shows the details box, 'required' also blocks submit until it is filled
  notes: 'none' | 'optional' | 'required';
}

export const CANCELLATION_REASONS: CancellationReason[] = [
  { value: 'dealer_conflict', label: 'Dealer Conflict', notes: 'optional' },
  { value: 'organization_conflict', label: 'Organization Conflict', notes: 'optional' },
  { value: 'inclement_weather', label: 'Inclement Weather', notes: 'optional' },
  { value: 'other', label: 'Other', notes: 'required' },
];

export const cancellationReasonLabel = (value?: string | null): string =>
  CANCELLATION_REASONS.find((r) => r.value === value)?.label || '';
